import { Halftone } from './Halftone';
import './Avatar.css';

interface Props {
  name: string;
  src?: string | null;
  size?: '2xs' | 'xs' | 'sm' | 'md' | 'lg';
  founding?: boolean; // founding-member seal + accent ring
}

function initials(name: string) {
  return name
    .split(' ')
    .map((w) => w[0]?.toUpperCase() ?? '')
    .slice(0, 2)
    .join('');
}

export function Avatar({ name, src, size = 'md', founding }: Props) {
  return (
    <span
      className={`avatar avatar--${size} ${founding ? 'avatar--founding' : ''}`}
      aria-label={founding ? `${name} · Founding member` : name}
    >
      {src ? (
        <img src={src} alt={name} />
      ) : (
        <>
          {/* initials placeholder carries the brand texture, not a flat block */}
          <span className="avatar__halftone" aria-hidden="true">
            <Halftone type="whisper" />
          </span>
          <span className="avatar__initials">{initials(name)}</span>
        </>
      )}
      {founding && (
        <span className="avatar__seal" aria-hidden="true" title="Founding member" />
      )}
    </span>
  );
}
